import BookmakerImage from '../../../../assets/onboarding/onboarding-bookmaker-image.webp';
import QuestionnaireImage from '../../../../assets/onboarding/customer-onboarding-questionnaire-image.webp';
import ProjectPlanImage from '../../../../assets/onboarding/customer-onboarding-project-plan-image.webp';
import BookOutlineImage from '../../../../assets/onboarding/customer-onboarding-book-outline-image.webp';
import InterviewImage from '../../../../assets/onboarding/customer-onboarding-interview-image.webp';
import PhotoUploaderImage from '../../../../assets/onboarding/customer-onboarding-photo-uploader-image.webp';
import CoverCreatorImage from '../../../../assets/onboarding/customer-onboarding-cover-creator-image.webp';
import DraftToolImage from '../../../../assets/onboarding/onboarding-draft-tool-image.webp';
import ProofImage from '../../../../assets/onboarding/customer-onboarding-proof-image.webp';
import { ROUTES } from '../../../router';

/* TODO
  add video links - videoHref - when thay will be ready
*/
const translationOptions = { ns: i18next.Namespace.COMMON };

const getCustomerOnboardingContent = () => ([
  {
    id: 0,
    image: BookmakerImage,
    text: t('onboarding.customer.bookmaker.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.customer.bookmaker.name', translationOptions),
    title: t('onboarding.customer.bookmaker.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [],
  },
  {
    id: 1,
    image: ProjectPlanImage,
    text: t('onboarding.customer.projectPlan.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.customer.projectPlan.name', translationOptions),
    title: t('onboarding.customer.projectPlan.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [],
  },
  {
    id: 2,
    image: QuestionnaireImage,
    text: t('onboarding.customer.questionnaire.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.customer.questionnaire.name', translationOptions),
    title: t('onboarding.customer.questionnaire.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.questionnaire.general.path],
  },
  {
    id: 3,
    image: InterviewImage,
    text: t('onboarding.customer.interview.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.customer.interview.name', translationOptions),
    title: t('onboarding.customer.interview.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.interviews.general.path],
  },
  {
    id: 4,
    image: BookOutlineImage,
    text: t('onboarding.customer.bookOutline.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.customer.bookOutline.name', translationOptions),
    title: t('onboarding.customer.bookOutline.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.outline.general.path],
  },
  {
    id: 5,
    image: PhotoUploaderImage,
    text: t('onboarding.customer.photoUploader.description', translationOptions),
    videoLinkText: t('onboarding.defaultTextForVideoLink', translationOptions), // Watch a video to see details.
    videoHref: 'https://www.loom.com/share/cb9f07902d4d417cb2b99d93d3d4d8dc',
    email: '',
    navTitle: t('onboarding.customer.photoUploader.name', translationOptions),
    title: t('onboarding.customer.photoUploader.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.photos.general.path],
  },
  {
    id: 6,
    image: CoverCreatorImage,
    text: t('onboarding.customer.coverCreator.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.customer.coverCreator.name', translationOptions),
    title: t('onboarding.customer.coverCreator.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.coverCreator.general.path],
  },
  {
    id: 7,
    image: DraftToolImage,
    text: t('onboarding.customer.draft.description', translationOptions),
    videoLinkText: '',
    videoHref: '',
    email: '',
    navTitle: t('onboarding.customer.draft.name', translationOptions),
    title: t('onboarding.customer.draft.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.draft.byChapterIndex.path],
  },
  {
    id: 8,
    image: ProofImage,
    text: t('onboarding.customer.finalBook.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.customer.finalBook.name', translationOptions),
    title: t('onboarding.customer.finalBook.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.proof.general.path],
  },
]);

export default getCustomerOnboardingContent;
